import {useEffect} from "react";
import * as yup from "yup";
import UserForm from "./UserForm";
import {useFormik} from "formik";
import PageLayout from "../../components/PageLayout/PageLayout";
import Button from "../../components/Button/Button";
import baseFormStyles from "../../components/BaseForm.module.scss";
import UserActions from "../../api/UsersActions";
import useUser from "../../contexts/userContext/useUser";

const validationSchema = yup.object({
    name: yup.string().required("Name is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    password: yup.string().min(1),
    confirmPassword: yup.string()
        .oneOf([yup.ref('password'), null], "Passwords must match")
});
const UserProfile = () => {
    const {user, updateUser} = useUser();
    const id = user?.id;

    const formik = useFormik({
        initialValues: {
            name: null,
            surname: null,
            email: null,
            changePassword: false,
            password: null,
            confirmPassword: null,
            role: null,
            image: null,
        },
        validationSchema,
        onSubmit: values => UserActions.updateUser(values.id, values, res => {
            formik.setValues({...res, changePassword: false});
            updateUser(res);
        })
    })

    useEffect(() => {
        if (id) {
            UserActions.getUser(id, res => formik.setValues(res))
        }
    }, [id]);


    return (
        <PageLayout
            titlePage="My profile"
            className={baseFormStyles['base-form']}
            actions={
                <Button type="submit" form="userForm">
                    Save
                </Button>
            }
        >
            <UserForm
                isOwnProfile={true}
                formik={formik}
            />
        </PageLayout>
    );
};

export default UserProfile;